import DashboardIcon from '@mui/icons-material/Dashboard';
import WorkIcon from '@mui/icons-material/Work';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import Groups2Icon from '@mui/icons-material/Groups2';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import SettingsIcon from '@mui/icons-material/Settings';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import WorkHistoryIcon from '@mui/icons-material/WorkHistory';
import ViewComfyAltIcon from '@mui/icons-material/ViewComfyAlt';
import { LayoutDashboard, MapPin } from 'lucide-react';
import { hasPermission } from '../../utils/permission';

export const getSideBarMenuRoutes = ({ isClientHqEnabled }) => [
    {
        id: 1,
        title: 'Dashboard',
        icon: DashboardIcon,
        href: '/dashboard',
        permissions: ['ROLE_BASE_PERMISSION_RECRUIT_INDEX_VIEW_DASHBOARD'],
    },
    {
        id: 2,
        title: 'Positions',
        icon: WorkIcon,
        href: '/positions',
        permissions: ['ROLE_BASE_PERMISSION_RECRUIT_INDEX_LIST_POSITIONS'],
    },
    {
        id: 3,
        title: 'Change Policies',
        icon: InsertDriveFileIcon,
        href: '/changerequest/crpolicies',
        permissions: ['ROLE_BASE_PERMISSION_RECRUIT_INDEX_LIST_CHANGE_REQUEST_POLICIES'],
    },
    {
        id: 4,
        title: 'Recruitment Policies',
        icon: WorkHistoryIcon,
        href: '/recruitmentPolicies',
        permissions: ['ROLE_BASE_PERMISSION_RECRUIT_INDEX_FETCH_RECRUITMENT_POLICY'],
    },
    {
        id: 5,
        title: 'Change Requests',
        icon: ChangeCircleIcon,
        href: '/changerequests',
        permissions: ['ROLE_BASE_PERMISSION_RECRUIT_INDEX_LIST_CHANGE_REQUESTS'],
    },
    {
        id: 6,
        title: 'Companies',
        icon: ManageAccountsIcon,
        href: '/company',
        permissions: ['ROLE_BASE_PERMISSION_SYSTEM_INDEX_LIST_COMPANIES'],
    },
    {
        id: 7,
        title: 'Users',
        icon: Groups2Icon,
        href: '/users',
        permissions: ['ROLE_BASE_PERMISSION_EMPLOYEE_INDEX_LIST_SECUSER'],
    },
    // {
    //   id: 8,
    //   title: 'Contacts',
    //   icon: MailOutlineIcon,
    //   href: '/contacts',
    //   permissions: ['ROLE_BASE_PERMISSION_INDEX_LIST_SIMPLE_CONTACTS'],
    // },
    {
        id: 9,
        title: 'Custom Attributes',
        icon: ViewComfyAltIcon,
        href: '/masterCustomAttributes',
        permissions: ['ROLE_BASE_PERMISSION_SYSTEM_INDEX_VIEW_MASTER_CUSTOM_ATTRIBUTE'],
    },
    ...(isClientHqEnabled
        ? [
              {
                  id: 21,
                  title: 'Dashboard',
                  icon: LayoutDashboard,
                  href: '/client/dashboard',
                  permissions: ['ROLE_BASE_PERMISSION_PRE_HQ_DASHBOARD'],
              },
              {
                  id: 22,
                  title: 'Demand Plan',
                  icon: MapPin,
                  href: '/client/positions',
                  permissions: ['ROLE_BASE_PERMISSION_PRE_HQ_LIST_POSITIONS'],
              },
              {
                  id: 24,
                  title: 'Review Policies',
                  icon: InsertDriveFileIcon,
                  href: '/client/reviewrequest/reviewpolicies',
                  permissions: ['ROLE_BASE_PERMISSION_PRE_HQ_LIST_REVIEW_POLICY'],
              },
          ]
        : []),
    {
        id: 99,
        title: 'Settings',
        icon: SettingsIcon,
        permissions: [], //["ROLES_CUSTOM_ATTRIBUTE", "ROLES_ROLES"],
        routes: [
            {
                id: 100,
                title: 'Demand Attributes',
                href: '/settings/demand-attributes',
                permissions: [
                    'ROLE_BASE_PERMISSION_INDEX_LIST_META_OBJECT_DEFN',
                    'ROLE_BASE_PERMISSION_INDEX_VIEW_META_OBJECT_DEFN',
                ],
            },
            {
                id: 101,
                title: 'Change Policy Roles',
                href: '/settings/change-policy/roles',
                permissions: ['ROLE_BASE_PERMISSION_RECRUIT_INDEX_CREATE_ROLES_FOR_APPROVERS'],
            },
            {
                id: 102,
                title: 'Roles',
                icon: LocationOnIcon,
                href: '/settings/roles',
                permissions: ['ROLE_BASE_PERMISSION_SECROLE_LIST'],
            },
            {
                id: 103,
                title: 'Recruitment Policy Attributes',
                icon: WorkHistoryIcon,
                href: '/settings/recruitment-policy/attributes',
                permissions: ['ROLE_BASE_PERMISSION_RECRUIT_INDEX_PRE_CREATE_RULE_SETTINGS_FOR_RECRUITMENT_POLICY'],
            },
            {
                id: 104,
                title: 'Locations',
                icon: LocationOnIcon,
                href: '/settings/locations',
                permissions: ['ROLE_BASE_PERMISSION_INDEX_LIST_LOCATIONS'],
            },
            {
                id: 105,
                title: 'Designations',
                icon: LocationOnIcon,
                href: '/settings/designations',
                permissions: ['ROLE_BASE_PERMISSION_INDEX_LIST_DESIGNATIONS'],
            },
            {
                id: 106,
                title: 'Departments',
                href: '/settings/departments',
                permissions: ['ROLE_BASE_PERMISSION_INDEX_LIST_DEPARTMENTS'],
            },
            {
                id: 107,
                title: 'Refresh Integation',
                href: '/settings/update-integration',
                permissions: ['ROLE_BASE_PERMISSION_COMPANY_CONFIG_UPDATE'],
            },
            {
                id: 108,
                title: 'Modify Position Ext ID',
                href: '/settings/modify-position-external-ids',
                permissions: ['ROLE_BASE_PERMISSION_RECRUIT_INDEX_UPDATE_EXTERNAL_ENTITY_ID'],
            },
            !isClientHqEnabled && {
                id: 109,
                title: 'Bulk Upload Position Data',
                href: '/settings/upload-position-data',
                permissions: ['ROLE_BASE_PERMISSION_RECRUIT_INDEX_IMPORT_POSITIONS_DATA'],
            },
            {
                id: 110,
                title: 'Request Maps',
                icon: LocationOnIcon,
                href: '/settings/request-maps',
                permissions: ['ROLE_SUPER_ADMINISTRATOR', 'ROLE_BASE_PERMISSION_SYSCONFIG_UPDATE'],
            },
            {
                id: 111,
                title: 'System Permissions',
                icon: LocationOnIcon,
                href: '/settings/system-permissions',
                permissions: ['ROLE_SUPER_ADMINISTRATOR', 'ROLE_BASE_PERMISSION_SYSCONFIG_UPDATE'],
            },
            isClientHqEnabled && {
                id: 112,
                title: 'Review Policy Roles',
                href: '/client/settings/review-policy/roles',
                permissions: ['ROLE_BASE_PERMISSION_PRE_HQ_LIST_REVIEW_POLICY_ROLES'],
            },
        ],
    },
];

export const getSidebarItems = (permissions, { isClientHqEnabled }, routes = null) => {
    if (!routes.length) return routes;

    const authorizedItems = routes
        .map((item) => {
            let newItem = { ...item };
            if (newItem.routes) {
                newItem.routes = getSidebarItems(permissions, { isClientHqEnabled }, newItem.routes);
            }
            return newItem;
        })
        .filter((item) => hasPermission(permissions, item.permissions, item?.permissionsNA));

    const uniqueItemObject = {};
    authorizedItems.forEach((item) => (uniqueItemObject[item.id] = item));

    return Object.values(uniqueItemObject);
};
